import moment from 'moment'
import { z } from 'zod'

export const EditProcessDataSchema = (isSportsOrAviationAccident) =>
	z
		.object({
			admissionDate: z.string(),
			accidentDate: z.string(),
			insuranceNumber: z.string().optional(),
			biologicalRisk: z.boolean().optional(),
			isPensioner: z.boolean().optional(),
			pensionerDate: z.string().optional(),
			managementType: z.string(),
			claimsManager: z.string().optional(),
			accidentSite: z.string().optional(),
			accidentDescription: z.string(),
			administrativeTransport: z.boolean().optional(),
			processTags: z.array(z.string()).optional(),
		})
		.superRefine((data, ctx) => {
			const {
				admissionDate,
				accidentDate,
				isPensioner,
				pensionerDate,
				accidentSite,
			} = data

			if (!moment(admissionDate).isValid()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Invalid date',
					path: ['admissionDate'],
				})
			}

			if (!moment(accidentDate).isValid()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Invalid date',
					path: ['accidentDate'],
				})
			}

			if (moment(admissionDate).diff(moment(accidentDate)) < 0) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Accident date must be lower than admission date',
					path: ['accidentDate'],
				})
			}

			if (isPensioner && !moment(pensionerDate).isValid()) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Invalid date',
					path: ['pensionerDate'],
				})
			}

			if (isSportsOrAviationAccident && !accidentSite) {
				ctx.addIssue({
					code: z.ZodIssueCode.custom,
					message: 'Required',
					path: ['accidentSite'],
				})
			}
		})
